<template>
  <div class="flex flex-col gap-4" :class="errorShow ? 'error' : ''">
    <div class="flex flex-col gap-1">
      <p class="opacity-50">{{ labelText }}:</p>

      <div class="flex gap-2">
        <label
          v-for="group in optionGroups"
          :key="group.id"
          class="input-room-wrapp relative px-4 py-2 cursor-pointer select-none"
        >
          <input
            type="checkbox"
            :name="name"
            class="absolute left-[-99999px] opacity-0 peer"
            :checked="selectedGroups.includes(group)"
            @input="handleInput(group)"
          />
          <span
            class="
              input-room-border
              absolute
              inset-0
              bg-white
              input-border
              duration-200
              peer-checked:bg-blue
            "
          ></span>
          <span class="relative z-10 duration-200 peer-checked:text-white">{{
            group.text
          }}</span>
        </label>
      </div>
    </div>

    <p v-if="errorShow" class="text-xs text-red">{{ errorText }}</p>
  </div>
</template>

<script>
import uniq from 'lodash/uniq'
import flatten from 'lodash/flatten'

export default {
  name: 'inputRooms',
  data() {
    return {
      selectedGroups: []
    }
  },
  props: {
    labelText: {
      type: String,
      default: '',
    },
    name: String,
    value: {
      type: Array,
      default: [],
    },
    errorShow: {
      type: Boolean,
      default: false,
    },
    errorText: {
      type: String,
      default: 'This field is required',
    },
    apartments: {
      type: Array,
      default: [],
    },
    groupIfMoreThan: {
      type: Number,
      default: 4,
    }
  },
  computed: {
    options() {
      return uniq(this.apartments.map((a) => a.rooms)).sort()
    },
    optionGroups() {
      const lessThanThreshold = this.options.filter(o => o < this.groupIfMoreThan)
      const moreThanThreshold = this.options.filter(o => o >= this.groupIfMoreThan)
      return [
        ...lessThanThreshold.map(o => ({ id: o, text: o, groupedOptions: [o] })),
        { id: this.groupIfMoreThan, text: `${this.groupIfMoreThan}+`, groupedOptions: moreThanThreshold }
      ]
    }
  },
  methods: {
    handleInput(group) {
      const index = this.selectedGroups.indexOf(group)

      if (index === -1) {
        this.selectedGroups =[...this.selectedGroups, group]
      } else {
        this.selectedGroups = [
          ...this.selectedGroups.slice(0, index),
          ...this.selectedGroups.slice(index + 1),
        ]
      }

      this.$emit('input', flatten(this.selectedGroups.map(g => g.groupedOptions)))
    },
  },
}
</script>
